import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import pl from './pl.json';

export const resources = {
  en: {
    translation: en,
  },
  pl: {
    translation: pl,
  },
};

const language = localStorage.getItem('language');

i18n.use(initReactI18next).init({
  compatibilityJSON: 'v3',
  resources,
  lng: language || 'en',
  // lng: 'pl',
  interpolation: {
    escapeValue: false,
  },
  fallbackLng: {
    default: ['pl'],
  },
  fallbackNS: ['translation'],
  debug: false,
});

export default i18n;
